module.exports = __webpack_public_path__ + "static/media/horseracing-icon.1944beda.svg";